<!-- .block-slideshow -->
<style>
    .slider-container{
        width: calc(100% );
        /* margin-left: 25px; */
    }
    .slider-container-width{
        width: 255px;
    }
    @media screen and (max-width: 1200px) {
        .slider-container-width{
            width: 210px;
        }
        .slider-container{
            width: calc(100% );
        }
    }
    @media screen and (max-width: 991px) {
        .slider-container-width{
            display: none;   
        }
        .slider-container{
            width: 100%;
            margin-left: 0;
        }
    }
</style>

<div class="block-slideshow block" [ngClass]="{'block-slideshow--layout--full': !withDepartments, 'block-slideshow--layout--with-departments': withDepartments}">
    <div class="container">
        <div class="d-flex flex-wrap flex-row">
            <!-- <div *ngIf="withDepartments" class="slider-container-width" appDepartmentsArea>
               


            </div> -->
            <!-- <div class="col-12" [ngClass]="{'col-lg-12': !withDepartments, 'col-lg-9': withDepartments}"> -->
                
                <div class="slider-container">
                    <div class="block-slideshow__body ml-0">
                        <owl-carousel-o *ngIf="slides?.length" [options]="options" appOwlPreventClick>
                            <ng-template *ngFor="let slide of slides" carouselSlide>
                                <a class="block-slideshow__slide" [routerLink]="[slide.link]" appClick>
                                    <div class="block-slideshow__slide-image block-slideshow__slide-image--desktop d-lg-block d-none" [ngStyle]="{'background-image': 'url('+(slide.largeimage)+')'}"></div>
                                    <div class="block-slideshow__slide-image block-slideshow__slide-image--desktop d-sm-block d-none d-lg-none" [ngStyle]="{'background-image': 'url('+(slide.mediumimage)+')'}"></div>
                                    <div class="block-slideshow__slide-image block-slideshow__slide-image--mobile d-sm-none d-block" [ngStyle]="{'background-image': 'url('+slide.smallimage+')'}"></div>
                                    <div *ngIf="slide.contentshow=='Yes'" class="block-slideshow__slide-content">
                                        <div class="block-slideshow__slide-title" [innerHTML]="sanitizer.bypassSecurityTrustHtml(slide.titletext)"></div>
                                        <div class="block-slideshow__slide-text" [innerHTML]="sanitizer.bypassSecurityTrustHtml(slide.contenttext)"></div>
                                        <div class="block-slideshow__slide-button">
                                            <span class="btn btn-primary btn-lg">{{slide.buttontext}}</span>
                                        </div>
                                    </div>
                                </a>
                            </ng-template>
                        </owl-carousel-o>
                    </div>
                </div>
                <!-- </div> -->
        </div>
    </div>
</div>
<!-- .block-slideshow / end -->
